exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-e55abd20]{opacity:1}[data-v-e55abd20] .el-switch__label{cursor:pointer !important}", ""]);

// exports
